import { createRouter, createWebHistory } from 'vue-router'
import sessionCache from '@/utils/cache'
import i18n from '@/locale/index'

const langs = ['zh', 'en', 'jp', 'th', 'ko', 'es', 'de', 'fr', 'ru', 'en_eu', 'en_us', 'zh_tw']
const langReg = langs.join('|')
const navigatorLan = {'ja': 'jp','tw':'zh_tw','de':'en_eu'}
const curLan = ['zh', 'en', 'ja', 'th', 'ko', 'de', 'tw']
let acceptLanguage = curLan.includes(window.navigator.language.split('-')[0]) ? ['ja','tw','de'].includes(window.navigator.language.split('-')[0]) ? navigatorLan[window.navigator.language.split('-')[0]] : window.navigator.language.split('-')[0]: 'zh'
console.log('acceptLanguage1',acceptLanguage, window.navigator)

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { isWechat } from '@/utils/wechat'
const routes = [
  {
    path: '/',
    redirect:'/index'
  },
  {
    path: '/index',
    name: 'index',
    component: () => import('../views/index/index.vue'),
    meta: {
      title: i18n.global.t('pages.index'),
    },
  },
  {
    path: '/:lang(' + langReg + ')/index',
    name: 'home',
    component: () => import('../views/index/index.vue'),
    meta: {
      title: i18n.global.t('pages.index'),
    },
  },
  {
    path: '/:lang(' + langReg + ')/resource',
    name: 'resource',
    component: () => import('../views/index/resource.vue'),
    meta: {
      title: 'resource',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/thx',
    name: 'thx',
    component: () => import( '../views/comm/thx.vue'),
    meta: {
      title: i18n.global.t('pages.thx'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/investment',
    name: 'investment',
    component: () => import('../views/index/investment.vue'),
    meta: {
      title: i18n.global.t('pages.investment'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/ESG',
    name: 'ESG',
    component: () => import('../views/index/ESG.vue'),
    meta: {
      title: 'ESG',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/search',
    name: 'search',
    component: () => import('../views/index/search.vue'),
    meta: {
      title: i18n.global.t('pages.search'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta: {
      title: i18n.global.t('pages.login'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/register',
    name: 'register',
    component: () => import('../views/login/register.vue'),
    meta: {
      title: i18n.global.t('pages.register'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/wechatLogin',
    name: 'wechatLogin',
    component: () => import('../views/login/wechatLogin.vue'),
    meta: {
      title: i18n.global.t('pages.wechatLogin'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/deregister',
    name: 'deregister',
    component: () => import('../views/login/deregister.vue'),
    meta: {
      title: i18n.global.t('pages.deregister'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/productList',
    name: 'product',
    component: () => import('../views/product/product_lists.vue'),
    meta: {
      title: i18n.global.t('pages.productLists'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/productList/:id',
    name: 'productList',
    component: () => import('../views/product/product_list.vue'),
    meta: {
      title: i18n.global.t('pages.productLists'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/productDetails/:id',
    name: 'productDetails',
    component: () => import('../views/product/product_details.vue'),
    meta: {
      title: i18n.global.t('pages.productDetails'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/productComparison',
    name: 'productComparison',
    component: () => import('../views/product/productComparison.vue'),
    meta: {
      title: i18n.global.t('pages.productComparison'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/case',
    name: 'case',
    component: () => import( '../views/solution/case.vue'),
    meta: {
      title: i18n.global.t('pages.case'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/caseDetail/:id',
    name: 'caseDetail',
    component: () => import( '../views/solution/caseDetail.vue'),
    meta: {
      title: i18n.global.t('pages.caseDetail'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/application/:id',
    name: 'application',
    component: () => import( '../views/solution/application.vue'),
    meta: {
      title: i18n.global.t('pages.solution'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/industry/:id',
    name: 'industry',
    component: () => import( '../views/solution/industry.vue'),
    meta: {
      title: i18n.global.t('pages.solution'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/productLevel/:id',
    name: 'productLevel',
    component: () => import( '../views/solution/productLevel.vue'),
    meta: {
      title: i18n.global.t('pages.solution'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/service',
    name: 'service',
    component: () => import( '../views/service/service.vue'),
    meta: {
      title: i18n.global.t('pages.service'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/repair',
    name: 'repair',
    component: () => import( '../views/service/repair.vue'),
    meta: {
      title: i18n.global.t('pages.repair'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/repairList',
    name: 'repairList',
    component: () => import( '../views/service/repairList.vue'),
    meta: {
      title: i18n.global.t('pages.repairList'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/repairDetail/:id',
    name: 'repairDetail',
    component: () => import( '../views/service/repairDetail.vue'),
    meta: {
      title: i18n.global.t('pages.repairDetail'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/showRoom',
    name: 'showRoom',
    component: () => import( '../views/service/showRoom.vue'),
    meta: {
      title: i18n.global.t('pages.showRoom'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/jakaAcademy',
    name: 'jakaAcademy',
    component: () => import( '../views/service/jakaAcademy.vue'),
    meta: {
      title: i18n.global.t('pages.jakaAcademy'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/download',
    name: 'download',
    component: () => import( '../views/service/download.vue'),
    meta: {
      title: i18n.global.t('pages.download'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/commonQuestion',
    name: 'commonQuestion',
    component: () => import( '../views/service/commonQuestion.vue'),
    meta: {
      title: i18n.global.t('pages.commonQuestion'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/provider',
    name: 'provider',
    component: () => import( '../views/service/provider.vue'),
    meta: {
      title: i18n.global.t('pages.provider'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/virtual',
    name: 'virtual',
    component: () => import( '../views/service/virtual.vue'),
    meta: {
      title: i18n.global.t('pages.virtual'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/jaka+',
    name: 'jaka+',
    component: () => import( '../views/jaka/jaka+.vue'),
    meta: {
      title: 'JAKA+',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/jakaHotline',
    name: 'jakaHotline',
    component: () => import( '../views/jaka/jakaHotline.vue'),
    meta: {
      title: 'JAKA Hotline',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/jakaList/:id',
    name: 'jakaList',
    component: () => import( '../views/jaka/jakaList.vue'),
    meta: {
      title: 'JAKA+',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/jakaDetail/:id',
    name: 'jakaDetail',
    component: () => import( '../views/jaka/jakaDetail.vue'),
    meta: {
      title: 'JAKA+',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/about',
    name: 'about',
    component: () => import('../views/about/about.vue'),
    meta: {
      title: i18n.global.t('pages.about'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/contact',
    name: 'contact',
    component: () => import( '../views/about/contact.vue'),
    meta: {
      title: i18n.global.t('pages.contact'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/join',
    name: 'join',
    component: () => import( '../views/about/join.vue'),
    meta: {
      title: i18n.global.t('pages.join'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/position',
    name: 'position',
    component: () => import( '../views/about/position.vue'),
    meta: {
      title: i18n.global.t('pages.position'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/news',
    name: 'news',
    component: () => import( '../views/about/news.vue'),
    meta: {
      title: i18n.global.t('pages.news'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/newsDetail/:id',
    name: 'newsDetail',
    component: () => import( '../views/about/newsDetail.vue'),
    meta: {
      title: i18n.global.t('pages.newsDetail'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/flsm',
    name: 'flsm',
    component: () => import( '../views/comm/flsm.vue'),
    meta: {
      title: i18n.global.t('pages.flsm'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/imprint',
    name: 'imprint',
    component: () => import( '../views/comm/flsm.vue'),
    meta: {
      title: i18n.global.t('pages.flsm'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/cooperationIntent',
    name: 'cooperationIntent',
    component: () => import( '../views/comm/cooperationIntent.vue'),
    meta: {
      title: i18n.global.t('pages.cooperationIntent'),
    },
  },
  // {
  //   path: '/map',
  //   name: 'map',
  //   component: () => import( '../views/comm/map.vue'),
  //   meta: {
  //     title: 'jaka',
  //   },
  // },
  // {
  //   path: '/ystk',
  //   name: 'ystk',
  //   component: () => import( '../views/comm/ystk.vue'),
  //   meta: {
  //     title: 'jaka',
  //   },
  // },
  // 预览 Preview
  {
    path: '/:lang(' + langReg + ')?/preview/index',
    name: '1home',
    component: () => import('../views/index/index_preview.vue'),
    meta: {
      title: i18n.global.t('pages.index'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/resource',
    name: 'lresource',
    component: () => import('../views/index/resource_preview.vue'),
    meta: {
      title: 'resource',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/investment',
    name: '1investment',
    component: () => import('../views/index/investment_preview.vue'),
    meta: {
      title: i18n.global.t('pages.investment'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/ESG',
    name: '1ESG',
    component: () => import('../views/index/ESG_preview.vue'),
    meta: {
      title: 'ESG',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/productList',
    name: '1productLists',
    component: () => import('../views/product/product_lists_preview.vue'),
    meta: {
      title: i18n.global.t('pages.productLists'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/productList/:id',
    name: '1productListPreview',
    component: () => import('../views/product/product_list_preview.vue'),
    meta: {
      title: i18n.global.t('pages.productLists'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/productDetails/:id',
    name: '1productDetailsPreview',
    component: () => import('../views/product/product_details_preview.vue'),
    meta: {
      title: i18n.global.t('pages.productDetails'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/case',
    name: '1case',
    component: () => import( '../views/solution/case.vue'),
    meta: {
      title: i18n.global.t('pages.case'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/caseDetail/:id',
    name: '1caseDetailPreview',
    component: () => import( '../views/solution/caseDetail_preview.vue'),
    meta: {
      title: i18n.global.t('pages.caseDetail'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/application/:id',
    name: '1applicationPreview',
    component: () => import( '../views/solution/application_preview.vue'),
    meta: {
      title: i18n.global.t('pages.solution'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/industry/:id',
    name: '1industryPreview',
    component: () => import( '../views/solution/industry_preview.vue'),
    meta: {
      title: i18n.global.t('pages.solution'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/productLevel/:id',
    name: '1productLevelPreview',
    component: () => import( '../views/solution/productLevel_preview.vue'),
    meta: {
      title: i18n.global.t('pages.solution'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/service',
    name: '1service',
    component: () => import( '../views/service/service_preview.vue'),
    meta: {
      title: i18n.global.t('pages.service'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/repair',
    name: 'lrepair',
    component: () => import( '../views/service/repair_preview.vue'),
    meta: {
      title: i18n.global.t('pages.repair'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/repairList',
    name: '1repairList',
    component: () => import( '../views/service/repairList_preview.vue'),
    meta: {
      title: i18n.global.t('pages.repairList'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/jakaAcademy',
    name: '1jakaAcademy',
    component: () => import( '../views/service/jakaAcademy_preview.vue'),
    meta: {
      title: i18n.global.t('pages.jakaAcademy'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/download',
    name: '1download',
    component: () => import( '../views/service/download_preview.vue'),
    meta: {
      title: i18n.global.t('pages.download'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/commonQuestion',
    name: '1commonQuestion',
    component: () => import( '../views/service/commonQuestion_preview.vue'),
    meta: {
      title: i18n.global.t('pages.commonQuestion'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/provider',
    name: '1provider',
    component: () => import( '../views/service/provider_preview.vue'),
    meta: {
      title: i18n.global.t('pages.provider'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/commonQuestionDetail',
    name: 'commonQuestionDetail',
    component: () => import( '../views/service/commonQuestion_preview_detail.vue'),
    meta: {
      title: i18n.global.t('pages.commonQuestion'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/jaka+',
    name: '1jaka+',
    component: () => import( '../views/jaka/jaka_preview.vue'),
    meta: {
      title: 'JAKA+',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/jakaHotline',
    name: 'ljakaHotline',
    component: () => import( '../views/jaka/jakaHotline_preview.vue'),
    meta: {
      title: 'JAKA Hotline',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/jakaList/:id',
    name: '1jakaList',
    component: () => import( '../views/jaka/jakaList_preview.vue'),
    meta: {
      title: 'JAKA+',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/jakaDetail/:id',
    name: '1jakaDetailPreview',
    component: () => import( '../views/jaka/jakaDetail_preview.vue'),
    meta: {
      title: 'JAKA+',
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/about',
    name: '1about',
    component: () => import('../views/about/about_preview.vue'),
    meta: {
      title: i18n.global.t('pages.about'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/contact',
    name: '1contact',
    component: () => import( '../views/about/contact_preview.vue'),
    meta: {
      title: i18n.global.t('pages.contact'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/join',
    name: '1join',
    component: () => import( '../views/about/join_preview.vue'),
    meta: {
      title: i18n.global.t('pages.join'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/position',
    name: '1position',
    component: () => import( '../views/about/position_preview.vue'),
    meta: {
      title: i18n.global.t('pages.position'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/news',
    name: '1news',
    component: () => import( '../views/about/news_preview.vue'),
    meta: {
      title: i18n.global.t('pages.news'),
    },
  },
  {
    path: '/:lang(' + langReg + ')?/preview/newsDetail/:id',
    name: '1newsDetailPreview',
    component: () => import( '../views/about/newsDetail_preview.vue'),
    meta: {
      title: i18n.global.t('pages.newsDetail'),
    },
  },
  {
    path: '/:lang(' + langReg + ')',
    redirect: {
      name: 'home'
    }
  },
  //404页面捕获
  {
    path: '/NotFound',
    name: 'test',
    component: () => import( '../views/comm/NotFound.vue'),
    meta: {
      title: 'NotFound',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/NotFound'
  },
]
// process.env.VUE_APP_BASE_URL
const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "act",
  // return 期望滚动到哪个的位置

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 200);
      });
    } else {
      // vue2.0  x  y  控制
      // vue3.0 left top 控制
      return { top: 0 };
    }
  },
})

NProgress.configure({ showSpinner: false })
router.beforeEach((to, from, next) => {
  NProgress.start()
  if (to.meta.title) {
    document.title = to.meta.title;
    if(to.path == '/login' ||  to.path == '/wechatLogin' ){
      if(sessionCache.getCache('jakaUserInfo')  ){
        if(sessionCache.getCache('jakaWhereFrom')){
          next(sessionCache.getCache('jakaWhereFrom'))
        }else{
          next(from.path)
        }
      }else{
        next()
      }
    }else if(to.path == '/register'){
      if(sessionCache.getCache('jakaUserInfo')  ){
        next(from.path)
      }else{
        next()
      }
    }else if(to.path == '/deregister'){
      if(sessionCache.getCache('jakaUserInfo') ){
        if(!sessionCache.getCache('jakaUserInfo').token){
          next(from.path)
        }else{
          next()
        }
      }else{
        next(from.path)
      }
    }else if(to.path == '/index' && isWechat && acceptLanguage !== 'zh'){
      if(acceptLanguage !== 'zh'){
        next(`/${acceptLanguage}`)
      }else{
        next()
      }
    }
    else{
      next()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})
export default router
